import * as React from 'react';

import AccessibleSVG from '../accessible-svg';
import { bdlGray80 } from '../../styles/variables';

import { Icon } from '../iconTypes';

const IconAdd = ({ className = '', color = bdlGray80, height = 16, title, width = 16 }: Icon) => (
    <AccessibleSVG
        className={`bdl-IconAdd ${className}`}
        height={height}
        title={title}
        viewBox="0 0 16 16"
        width={width}
    >
        <path className="fill-color" d="M8.5 2v5.5H14v1H8.5V14h-1V8.5H2v-1h5.5V2z" fill={color} fillRule="evenodd" />
    </AccessibleSVG>
);

export default IconAdd;
